import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "model";
/**
* @class PositivePayExceptionCheck
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @property {STRING} _account - The account of the check.
* @property {STRING} _accountName - The account name of the check.
* @property {STRING} _accountNumber - The account number of the check.
* @property {STRING} _issuedDate - The issued date of the check.
* @property {STRING} _checkNumber - The check number of the check.
* @property {STRING} _amount - The amount of the check.
* @property {STRING} _payee - The payee of the check.
* @property {STRING} _referenceNumber - The reference number of the check.
* @property {STRING} _type - The status type of the check.
* @extends BCMSRecord
* @example const record = model.positivePayChecks[0];
* const profile = new PositivePayCheck(record);
* @property {STRING} _id - The id of the positive pay check.
*/
export default class PositivePayExceptionCheck extends BCMSRecord {
    _id
    _account
    _issuedDate
    _checkNumber
    _amount
    _payee
    _referenceNumber
    _type
    _status
    _reason
    _action
    _returnReason

    constructor(record) {     
      super(record) 
    }
  }
  
  PositivePayExceptionCheck.define({
    "recordType": "positivePayExceptionChecks",
    "recordIDProp":"id",
    "className" : "PositivePayExceptionChecks",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {STRING} - gets the id 
         * @property set {STRING} - sets the id 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("id","_id"),

        /** 
         * @name account
         * @instance
         * @property get {STRING} - gets the id 
         * @property set {STRING} - sets the id 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToClass("account","_account",()=>Account),

        /** 
         * @name issuedDate
         * @instance
         * @property get {STRING} - gets the issuedDate 
         * @property set {STRING} - sets the issuedDate 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToDate("issuedDate","_issuedDate"),

        /** 
         * @name checkNumber
         * @instance
         * @property get {STRING} - gets the checkNumber 
         * @property set {STRING} - sets the checkNumber 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("checkNumber","_checkNumber"),

        /** 
         * @name amount
         * @instance
         * @property get {STRING} - gets the amount 
         * @property set {STRING} - sets the amount 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("amount","_amount"),

        /** 
         * @name payee
         * @instance
         * @property get {STRING} - gets the payee 
         * @property set {STRING} - sets the payee 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("payee","_payee"),

        /** 
         * @name referenceNumber
         * @instance
         * @property get {STRING} - gets the referenceNumber 
         * @property set {STRING} - sets the referenceNumber 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("referenceNumber","_referenceNumber"),

        /** 
         * @name type
         * @instance
         * @property get {STRING} - gets the type 
         * @property set {STRING} - sets the type 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("type","_type"),

        /** 
         * @name status
         * @instance
         * @property get {STRING} - gets the type 
         * @property set {STRING} - sets the type 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("status","_status"),

        /** 
         * @name reason
         * @instance
         * @property get {STRING} - gets the reason 
         * @property set {STRING} - sets the reason 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("reason","_reason"),

        /** 
         * @name action
         * @instance
         * @property get {STRING} - gets the action 
         * @property set {STRING} - sets the action 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("action","_action"),

        /** 
         * @name returnReason
         * @instance
         * @property get {STRING} - gets the returnReason 
         * @property set {STRING} - sets the returnReason 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("returnReason","_returnReason"),
        
    ]  
})




